import {
  CustomBlockRenderer,
  CustomTagRendererRecord,
  HTMLContentModel,
  defaultHTMLElementModels,
  useContentWidth,
} from 'react-native-render-html'
import { View } from 'react-native'
import WebView from 'react-native-webview'
import { isWeb } from 'tamagui'
import { HTML_IFRAME_SANDBOX } from '@constants/mediaTypes'
import { normalizeEmbedSrc, resolveEmbedSize } from '@utils/htmlEmbed'

// react-native-render-html descarta <iframe> por padrão: o modelo default do tag
// tem `contentModel: 'none'`, o que o transforma num TEmpty e faz o renderer
// devolver null (só img/picture vêm com contentModel block). Resultado: aula tipo
// Texto com embed colado (Thinglink, YouTube, Google Forms) renderizava um bloco
// vazio. Registramos o modelo como block + um renderer próprio — mesma estratégia
// do @native-html/iframe-plugin, sem a dependência extra e com o sandbox/
// isolamento que a área de membros já usa para embeds de terceiro.

export const HtmlIframeRenderer: CustomBlockRenderer =
  function HtmlIframeRenderer({ tnode }) {
    const contentWidth = useContentWidth()
    const src = normalizeEmbedSrc(tnode.attributes.src)

    if (!src) return null

    const { width, height } = resolveEmbedSize(tnode.attributes, contentWidth)
    const title = tnode.attributes.title || 'Conteúdo incorporado'

    if (isWeb) {
      return (
        <View style={{ width, height, marginBottom: 8 }}>
          <iframe
            src={src}
            title={title}
            sandbox={HTML_IFRAME_SANDBOX}
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            style={{ width: '100%', height: '100%', border: 0 }}
          />
        </View>
      )
    }

    return (
      <View style={{ width, height, marginBottom: 8, overflow: 'hidden' }}>
        <WebView
          source={{ uri: src }}
          style={{ backgroundColor: 'transparent' }}
          // Mesmo isolamento aplicado aos embeds de terceiro em MediaRender:
          // este WebView carrega um documento remoto colado pelo produtor, então
          // não compartilha nem grava storage/cookies do app, e a navegação
          // interna fica restrita a origens seguras.
          incognito
          sharedCookiesEnabled={false}
          thirdPartyCookiesEnabled={false}
          originWhitelist={['https://*']}
          allowsFullscreenVideo
          // iOS joga <video> no player fullscreen nativo por default; inline
          // mantém o embed dentro do layout da aula.
          allowsInlineMediaPlayback
          nestedScrollEnabled
        />
      </View>
    )
  }

export const htmlIframeRenderers: CustomTagRendererRecord = {
  iframe: HtmlIframeRenderer,
}

export const htmlIframeElementModels = {
  iframe: defaultHTMLElementModels.iframe.extend({
    contentModel: HTMLContentModel.block,
  }),
}
